import React from 'react';
import {footerTxt} from 'config/translate/variables'
import style from './style.scss'; //NOSONAR

const Footer = () => {
    return (
        <footer className="cart-footer">
            <div className="cart-footer-container">
                <span className="cart-footer-span-copyright">{footerTxt.copyright}</span>
            </div>
        </footer>
    )
}

export default Footer;
